import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LoanpendinglistreportService {


  constructor(private http: HttpClient) { }

  url = environment.serverAPI4 + "/api/goldloanpendinglist";

  searchGoldloanpendinglistReport(query: string, page: number, size: number, sort: string): Observable<Response[]> {

    const requestBody = {
      "searchQuery": query != null ? query.split("'").join('') : null,
      "groupBy": null

    };
    const queryParams = `?page=${page}&size=${size}&sort=${sort}`;

    return this.http.post<Response[]>(`${this.url}/condition/Pending${queryParams}`, requestBody);
  }

  getGoldLoanEligibleAmount(query: any) {

    const requestBody = {
      "searchQuery": query != null ? query.split("'").join('') : null,
      "groupBy": null,

    };

    return this.http.post<number>(`${this.url}/condition/Pending/loanEligibleAmount`, requestBody);
  }

  getGoldLoanInterestTotal(query: any) {

    const requestBody = {
      "searchQuery": query != null ? query.split("'").join('') : null,
      "groupBy": null,

    };

    return this.http.post<number>(`${this.url}/condition/Pending/interestAmount`, requestBody);
  }

    getGoldLoanloanAmount(query: any) {

    const requestBody = {
      "searchQuery": query != null ? query.split("'").join('') : null,
      "groupBy": null,

    };

    return this.http.post<number>(`${this.url}/condition/Pending/loanAmount`, requestBody);
  }

    getGoldEligibleAmount(query: any) {

    const requestBody = {
      "searchQuery": query != null ? query.split("'").join('') : null,
      "groupBy": null,

    };

    return this.http.post<number>(`${this.url}/condition/Pending/loanEligibleAmount`, requestBody);
  }

}
